<template>
  <a-modal v-model="modal" title="修改" width="450px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="需求数量"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="orderQuantity"
        :rules="rules.orderQuantity"
        v-if="fieldType==='orderQuantity'"
      >
        <a-input-number
          style="width: 80%"
          v-model="formData.orderQuantity"
          :min="0"
          :max="99999"
          :parser="(value) => `${value}`.replace(/\D/g, '')"
          :formatter="(value) => `${value}`.replace(/\D/g, '')" />
      </a-form-model-item>
      <a-form-model-item
        label="需求交期"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="deliveryDate"
        :rules="rules.deliveryDate"
        v-if="fieldType==='deliveryDate'"
      >
        <a-date-picker v-model="formData.deliveryDate" valueFormat="YYYY-MM-DD 00:00:00" style="width: 80%" :disabled-date="disabledEndDate" />
      </a-form-model-item>
      <a-form-model-item
        label="供应商选择"
        :labelCol="{ style: 'width: 100px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 100px ) !important;float:left'}"
        prop="vendorCode"
        :rules="rules.vendorCode"
        v-if="fieldType==='vendorCode'"
      >
        <a-select
          allowClear
          show-search
          option-filter-prop="children"
          v-model="formData.vendorCode"
          option-label-prop="label">
          <a-select-option v-for="(item) in supplierList" :key="item.realValue" :value="item.realValue" :label="item.label">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiAdjustSupplierComboBox } from '@/api/finished-goods-order'
import { apiScpAdjustQuantity, apiScpAdjustDeliveryDate, apiScpAdjustSupplier } from '@/api/scp/sporadicPlanPool/sporadicPlanPool'

export default {
  name: 'BatchEditModal',
  data() {
    return {
      modal: false,
      supplierList: [],
      formData: { deliveryDate: null, vendorCode: null, orderQuantity: null },
      loading: false,
      apiObj: {
        'orderQuantity': apiScpAdjustQuantity,
        'deliveryDate': apiScpAdjustDeliveryDate,
        'vendorCode': apiScpAdjustSupplier
      },
      rules: {
        vendorCode: [{ required: true, message: ' ', trigger: 'change' }],
        deliveryDate: [{ required: true, message: ' ', trigger: 'change' }],
        orderQuantity: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      fieldType: '', // 修改字段标识
      ids: [],
      selectRow: []
    }
  },
  methods: {
    moment,
    show (field, ids, selectRow) {
      this.fieldType = field // 区分修改字段标识
      this.ids = ids || []
      this.selectRow = selectRow || []
      if (field === 'vendorCode') {
        this.initGetSupplier()
      }
      this.formData.deliveryDate = null
      this.formData.vendorCode = null
      this.formData.orderQuantity = null
      this.modal = true
    },
    // 初始化获取供应商列表
    initGetSupplier() {
      this.supplierList = []
      const supplierCodeList = this.selectRow?.map(v => v.itemCode) || []
      this.loading = true
      apiAdjustSupplierComboBox(supplierCodeList).then(res => {
        if (res?.code === 200) {
          this.supplierList = res?.data || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 提交
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          let params = { ids: this.ids }
          if (this.fieldType === 'deliveryDate') {
            params.deliveryDate = this.$moment(this.formData.deliveryDate).format('YYYY-MM-DD HH:mm:ss')
          }
          params = { ...params, ...this.formData }
          this.loading = true;
          this.apiObj[this.fieldType](params).then(response => {
            if (response?.code === 200) {
              this.$message.success('修改完成')
              this.modal = false
              this.$emit("finallyUpdate")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 交期不可选历史日期
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    }
  }
}
</script>

<style scoped>

</style>
